"use client";

import React from "react";
import styled from "styled-components";
import EdenImage from "@churchofjesuschrist/eden-image";
import { jsx as _jsx } from "react/jsx-runtime";
const Image = styled(EdenImage).withConfig({
  componentId: "sc-1qycwea-0"
})(["height:auto;"]);

/**
 * Child component for `MediaModal` specific to displaying an image.
 * @param {object} props - The component props
 * @param {React.ReactNode} [props.attribution] -  Attribution or copyright
 * @param {React.ReactNode} [props.caption] - Caption to display with the image
 * @param {string} props.src - Image source
 * @param {string} [props.title] - Title to display with the image
 * @param {React.ReactNode} [props.tools] - A slot for one or more related tools (e.g., share and download buttons).
 * @param {number} [props.width] - The intrinsic width of the image in pixels. Must be an integer without a unit.
 * @param {number} [props.height] - The intrinsic height of the image in pixels. Must be an integer without a unit.
 * @param {string} [props.srcset] - Image srcset
 * @param {string} [props.sizes] - Image sizes
 * @param {string} [props.alt] - Defines text that can replace the image in the page.
 * @param {string} [props."aria-describedby"] - Unique id to be passed to the caption for use with screen readers.
 * @returns {React.ReactNode} - The MediaModal component.
 */
const ModalImage = ({
  ...props
}) => {
  // `attribution`, `caption`, `title`, and `tools` are read and displayed by the MediaModal, but attached to this component
  delete props.attribution;
  delete props.caption;
  delete props.title;
  delete props.tools;
  return /*#__PURE__*/_jsx(Image, {
    ...props
  });
};
ModalImage.displayName = "ModalImage";
export default ModalImage;